import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success',
  standalone: true,
  template: `
    <div class="flex flex-col items-center justify-center min-h-screen bg-green-50 text-green-800">
      <div class="flex items-center space-x-4">
        <img src="https://cdn-icons-png.flaticon.com/512/845/845646.png" alt="Success Icon" class="w-12 h-12" />
        <h1 class="text-3xl font-bold">Integration Successful</h1>
      </div>
      <p class="mt-4 text-lg">The integration was completed successfully!</p>
      <div class="flex space-x-4 mt-6">
        <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Instagram" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/145/145807.png" alt="LinkedIn" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" class="w-10 h-10" />
        <img src="https://cdn-icons-png.flaticon.com/512/281/281764.png" alt="Google" class="w-10 h-10" />
      </div>
      <button (click)="goHome()" class="mt-8 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">Go to Home</button>
    </div>
  `,
  styles: [],
})
export class SuccessComponent {
  constructor(private router: Router) {}

  goHome() {
    window.location.href = '/';
  }
}